import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';

import Layout from '../../../components/Checkout/Layout';
import Breadcrumb from '../../../components/Checkout/Breadcrumb';
import Summary from '../../../components/Checkout/Summary';
import Payment from '../../../components/Checkout/Payment';

import apiPayment from '../../../api/Payment';
import ApiPaymentFL from '../../../api/Payment/PaymentApiFL';
import ApiOrderFL from '../../../api/Order/OrderApiFL';
import ApiCart from '../../../api/Cart/CartApiFL';
import * as actionTypes from '../../../redux/types/types';

import Config, { spanish } from '../../../config/config';

class PaymentPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      content: null,
      errorMessage: '',
      showErrorMessage: false,
      referralId: null,
      cartInfo: [],
      processing: false,
      evoHtml: null,
      evoResult: null,
      evoFirma: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    this.setContent();
    this.getCartInfo();
  }

  setContent = async () => {
    const resp = await apiPayment.getContent();
    this.setState({ content: resp });
  };

  setReferalId = (referralId) => {
    this.setState({ referralId });
  };

  getCartInfo = async () => {
    // eslint-disable-next-line react/destructuring-assignment
    const { IdCarrito } = this.props.cartInfo;
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdCarrito,
    };
    const resp = await ApiCart.getCart(payload);
    if (resp.Codigo === 200) {
      this.setState({ cartInfo: resp.InfoCarrito });
      this.PaymentFunctions();
    }
  };

  PaymentFunctions = () => {
    const { cartInfo } = this.state;

    const setError = (message) => {
      this.setState({ errorMessage: message });
      this.setState({ showErrorMessage: true });
    };

    const setIsLoading = () => {
      this.setState({ isLoading: false });
    };

    const getHtmlEvo = async (SessionId, TokenEvo = null) => {
      this.setState({ isLoading: true });
      const payloadClientSession = {
        Cliente: Config.payment_services.client,
        Pais: 'MEX',
        Ambiente: Config.payment_services.environment,
        IdCarrito: cartInfo[0].idCarrito,
        CantidadPagar: parseFloat(cartInfo[0].Total),
        IdFbo: 0,
        operatorId: 'disabled',
        SessionId,
        TokenEvo,
      };
      const respClientSession = await ApiPaymentFL.getHtmlEvo(
        payloadClientSession
      );
      if (respClientSession.Codigo === 200) {
        this.setState({ evoHtml: respClientSession.EvoResponse.html });
        this.setState({ evoResult: respClientSession.EvoResponse.result });
        this.setState({ evoFirma: respClientSession.Firma });
      }
      if (respClientSession.Codigo !== 200 && respClientSession.Mensaje) {
        setError(respClientSession.Mensaje);
      }
      this.setState({ isLoading: false });
    };
    // eslint-disable-next-line no-undef
    PaymentSession.configure({
      fields: {
        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
        card: {
          nameOnCard: '#card-number',
          number: '#cardholder-name',
          expiryMonth: '#expiry-month',
          expiryYear: '#expiry-year',
          securityCode: '#security-code',
        },
      },
      // SPECIFY YOUR MITIGATION OPTION HERE
      frameEmbeddingMitigation: ['javascript'],
      callbacks: {
        initialized(response) {
          console.log(response.status);
          if (response.status === 'ok') setIsLoading(false);
        },
        formSessionUpdate(response) {
          // HANDLE RESPONSE FOR UPDATE SESSION
          if (response.status) {
            if (response.status === 'ok') {
              console.log(`Session updated with data: ${response.session.id}`);
              getHtmlEvo(response.session.id);
              // check if the security code was provided by the user
              if (response.sourceOfFunds.provided.card.securityCode) {
                console.log('Security code was provided.');
              }
              // check if the user entered a Mastercard credit card
              if (
                response.sourceOfFunds.provided.card.scheme === 'MASTERCARD'
              ) {
                console.log('The user entered a Mastercard credit card.');
              }
            } else if (response.status === 'fields_in_error') {
              console.log('Session update failed with field errors.');
              if (response.errors.cardNumber) {
                console.log('Card number invalid or missing.');
                setError('Card number invalid or missing.');
              }
              if (response.erors.expiryYear) {
                console.log('Expiry year invalid or missing.');
                setError('Expiry year invalid or missing.');
              }
              if (response.errors.expiryMonth) {
                console.log('Expiry month invalid or missing.');
                setError('Expiry month invalid or missing.');
              }
              if (response.errors.securityCode) {
                console.log('Security code invalid.');
                setError('Security code invalid.');
              }
            } else if (response.status === 'request_timeout') {
              console.log(
                `Session update failed with request timeout: ${response.errors.message}`
              );
              setError(
                `Session update failed with request timeout: ${response.errors.message}`
              );
            } else if (response.status === 'system_error') {
              console.log(
                `Session update failed with system error: ${response.errors.message}`
              );
              setError(
                `Session update failed with system error: ${response.errors.message}`
              );
            }
          } else {
            console.log(`Session update failed: ${response}`);
            setError(`Session update failed: ${response}`);
          }
        },
      },
      interaction: {
        displayControl: {
          formatCard: 'EMBOSSED',
          invalidFieldCharacters: 'REJECT',
        },
      },
    });
  };

  createOrder = async (payloadCreateOrder) => {
    const createOrderResp = await ApiOrderFL.createOrder(payloadCreateOrder);
    if (createOrderResp.Codigo === 200) {
      const { onAddOrderId } = this.props;
      const { history } = this.props;
      const lang = spanish ? '/mex/es-mx' : '/mex/en-us';
      onAddOrderId(createOrderResp.Confirmacion[0].IdPedido);
      history.push(`${lang}/checkout/success`);
      sessionStorage.removeItem('externalCustomer');
    }
  };

  onSubmitPayment = async () => {
    this.PaymentFunctions();
    // eslint-disable-next-line no-undef
    PaymentSession.updateSessionFromForm('card');
  };

  validatePayment = async () => {
    this.setState({ processing: true });
    const { referralInfo } = this.props;
    const { evoFirma } = this.state;
    const { cartInfo } = this.state;
    const resp = await ApiPaymentFL.getPaymentStatus(evoFirma);

    if (resp.Codigo !== 200) {
      this.setState({ evoResult: null });
      this.setState({ processing: false });
      this.setState({ errorMessage: resp.Mensaje });
      this.setState({ showErrorMessage: true });
    }
    if (resp.Codigo === 200 && resp.EvoStatus === 'SUCCESS') {
      this.setState({ evoResult: null });
      const payloadCreateOrder = {
        Cliente: Config.payment_services.client,
        Pais: 'MEX',
        Ambiente: Config.payment_services.environment,
        IdCarrito: cartInfo[0].idCarrito,
        IdFBOReferido: referralInfo.referralId ? referralInfo.referralId : 0,
      };
      this.createOrder(payloadCreateOrder);
    }
  };

  render() {
    const {
      content,
      showErrorMessage,
      errorMessage,
      referralId,
      processing,
      formValid,
      evoHtml,
      evoResult,
      isLoading,
    } = this.state;
    const { referralInfo, shippingCosts } = this.props;
    const title = spanish ? content?.TitleSpanish : content?.TitleEnglish;
    return (
      <Layout>
        <Helmet title={spanish ? 'Pago' : 'Payment'} />
        <Breadcrumb step={3} title={title} link="shipping" />
        <Payment
          content={content}
          onPaymentFormChange={this.onPaymentFormChange}
          onSubmitPayment={this.onSubmitPayment}
          showErrorMessage={showErrorMessage}
          errorMessage={errorMessage}
          processing={processing}
          formValid={formValid}
          evoHtml={evoHtml}
          evoResult={evoResult}
          validatePayment={this.validatePayment}
          isLoading={isLoading}
        />
        <Summary
          shippingCost={shippingCosts.totalShippingCost}
          shippingTax={shippingCosts.shippingTax}
          setReferalId={this.setReferalId}
          referralId={referralInfo.referralId}
          referralIdForm={referralId}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  cartInfo: state.cartInfo,
  referralInfo: state.referralInfo,
  shippingCosts: state.shippingCost,
});

const mapDispatchToProps = (dispatch) => ({
  onAddOrderId: (orderId) =>
    dispatch({ type: actionTypes.default.setOrderId, orderId }),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PaymentPage)
);
